import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid p-4" }
const _hoisted_2 = { style: {"position":"absolute","left":"-9999px","top":"-9999px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "cartao-dados",
  style: {"position":"absolute","top":"137px","left":"28px","color":"white","font-family":"Arial, sans-serif"}
}
const _hoisted_5 = { style: {"font-size":"13px","line-height":"12px","font-weight":"bold","margin-bottom":"0px","height":"32px","width":"280px"} }
const _hoisted_6 = { style: {"position":"absolute","font-size":"12px","font-weight":"bold","left":"2px","top":"30px"} }
const _hoisted_7 = { style: {"position":"absolute","font-size":"12px","font-weight":"bold","left":"95px","top":"30px"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "cartao-dependentes",
  style: {"position":"absolute","top":"35px","left":"190px","color":"white","text-align":"left","font-family":"Arial, sans-serif"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-12 text-center" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-info mb-3"
}
const _hoisted_14 = {
  key: 1,
  class: "alert alert-danger mb-3"
}
const _hoisted_15 = {
  key: 2,
  class: "text-center"
}
const _hoisted_16 = {
  class: "border rounded p-2",
  style: {"max-width":"100%","margin":"0 auto"}
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 3,
  class: "text-center py-5"
}

import { onMounted, ref, reactive } from 'vue'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
import { useRoute } from 'vue-router';

import config from "@/app.config.json";
import * as service from "@/services/clientesService";
import * as dependentesService from "@/services/clientesDependentesService";
import * as contratosService from "@/services/clientesContratosService";
import { fdata } from "@/utils/funcoes";

// Importe suas imagens
import cartaoFrente from '@/assets/images/cartao-frente.png'
import cartaoVerso from '@/assets/images/cartao-verso.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'CartaoPdf',
  setup(__props) {

const route = useRoute();
const frenteRef = ref(null)
const versoRef = ref(null)
const pdfUrl = ref('');
const qrCodeUrl = ref('');

var controle = reactive({
  model: {} as service.Cliente,
  dependentes: [] as dependentesService.Dependente[],
  contrato: null as contratosService.Contrato | null,
  status: "",
  erro: ""
});

onMounted(() => {
  console.log('Carregando cartão para ID:', route.params.id);
  if (route.params.id) {
    service.obterPorId(Number(route.params.id))
      .then(async r => {
        controle.model = r;

        const urlValidador = `${config.urlPainel}/validador/${r.clienteId}`;
        qrCodeUrl.value = await QRCode.toDataURL(urlValidador, { width: 200, margin: 1 });

        // Aguardar um pouco para garantir que as imagens carregaram
        setTimeout(() => {
          gerarPdf();
        }, 500);
      })
      .catch(error => {
        controle.erro = `Erro ao carregar: ${error}`;
      });

      dependentesService.obter({clienteId: Number(route.params.id)} as dependentesService.Filtros)
     .then(r => {
        controle.dependentes = r;
        // Aguardar um pouco para garantir que as imagens carregaram
      })
      .catch(error => {
        controle.erro = `Erro ao carregar: ${error}`;
      });

      contratosService.obter({clienteId: Number(route.params.id)} as contratosService.Filtros)
     .then(r => {
        controle.contrato = r[0] || null;
        // Aguardar um pouco para garantir que as imagens carregaram
      })
      .catch(error => {
        controle.erro = `Erro ao carregar: ${error}`;
      });
  }
})

const gerarPdf = async () => {
  if (!frenteRef.value || !versoRef.value) return

  controle.status = "Gerando PDF...";

  try {
    // Tamanho do cartão PVC: 86mm x 54mm
    const CARTAO_LARGURA_MM = 177
    const CARTAO_ALTURA_MM = 110
    
    // Margem superior esquerda
    const MARGEM_X = 0
    const MARGEM_Y = 0
    
    // Captura as imagens com alta resolução
    const [canvasFrente, canvasVerso] = await Promise.all([
      html2canvas(frenteRef.value, { 
        scale: 3,
        useCORS: true, 
        backgroundColor: '#ffffff',
        allowTaint: false,
        logging: false
      }),
      html2canvas(versoRef.value, { 
        scale: 3,
        useCORS: true, 
        backgroundColor: '#ffffff',
        allowTaint: false,
        logging: false
      })
    ])

    const frenteData = canvasFrente.toDataURL('image/PNG', 1.0)
    const versoData = canvasVerso.toDataURL('image/PNG', 1.0)

    // Criar PDF A4
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [177, 110] // Tamanho do cartão PVC em mm
    })

    // Página 1 - Frente do cartão no canto superior esquerdo
    pdf.addImage(
      frenteData, 
      'PNG', 
      MARGEM_X, 
      MARGEM_Y, 
      CARTAO_LARGURA_MM, 
      CARTAO_ALTURA_MM,
      '',
      'FAST'
    )

    // Adicionar bordas de corte do cartão (linhas guia)
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.1)
    pdf.rect(MARGEM_X, MARGEM_Y, CARTAO_LARGURA_MM, CARTAO_ALTURA_MM)

    // Nova página para o verso
    pdf.addPage()
    
    // Página 2 - Verso do cartão no canto superior esquerdo
    pdf.addImage(
      versoData, 
      'PNG', 
      MARGEM_X, 
      MARGEM_Y, 
      CARTAO_LARGURA_MM, 
      CARTAO_ALTURA_MM,
      '',
      'FAST'
    )

    // Adicionar bordas de corte do cartão (linhas guia)
    pdf.setDrawColor(200, 200, 200)
    pdf.setLineWidth(0.1)
    pdf.rect(MARGEM_X, MARGEM_Y, CARTAO_LARGURA_MM, CARTAO_ALTURA_MM)

    // Adicionar metadados
    pdf.setProperties({
      title: `Cartão PVC - ${controle.model.nome}`,
      subject: 'Cartão de Identificação',
      creator: 'Sistema PrevVida',
      keywords: 'cartão, pvc, identificação'
    })

    // Gerar Blob e exibir automaticamente
    const blob = pdf.output('blob')
    const url = URL.createObjectURL(blob)
    pdfUrl.value = url

    controle.status = "PDF gerado com sucesso!"

  } catch (error) {
    controle.erro = `Erro ao gerar PDF: ${error}`
    console.error('Erro detalhado:', error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        ref_key: "frenteRef",
        ref: frenteRef,
        class: "cartao-container",
        style: {"width":"320px","height":"202px","background":"white"}
      }, [
        _createElementVNode("img", {
          src: _unref(cartaoFrente),
          alt: "Frente do cartão PVC",
          style: {"width":"100%","height":"100%","object-fit":"cover","display":"block"}
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(controle).model.nome), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(controle).model.cpf), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(controle).model.clienteId), 1)
        ])
      ], 512),
      _createElementVNode("div", {
        ref_key: "versoRef",
        ref: versoRef,
        class: "cartao-container",
        style: {"width":"320px","height":"202px","background":"white"}
      }, [
        _createElementVNode("img", {
          src: _unref(cartaoVerso),
          alt: "Verso do cartão PVC",
          style: {"width":"100%","height":"100%","object-fit":"cover","display":"block"}
        }, null, 8, _hoisted_8),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).dependentes, (dep, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              style: {"font-size":"11px","font-weight":"bold","margin-bottom":"7px","line-height":"10px"},
              key: idx
            }, _toDisplayString(dep.nome), 1))
          }), 128))
        ]),
        (qrCodeUrl.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: qrCodeUrl.value,
              alt: "QR Code de validação",
              style: {"position":"absolute","top":"50%","left":"15px","transform":"translateY(calc(-50% - 10px))","width":"80px","height":"80px"}
            }, null, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_unref(controle).status && !pdfUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_unref(controle).status), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(controle).erro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
              _createTextVNode(_toDisplayString(_unref(controle).erro), 1)
            ]))
          : _createCommentVNode("", true),
        (pdfUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "alert alert-success mb-3" }, [
                _createElementVNode("i", { class: "fas fa-check-circle me-2" }),
                _createTextVNode(" Cartão gerado com sucesso! Pronto para impressão. ")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("iframe", {
                  src: pdfUrl.value,
                  style: {"width":"100%","height":"80vh","border":"none","border-radius":"8px"},
                  title: "Cartão PDF - Pronto para Impressão"
                }, null, 8, _hoisted_17)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mt-3" }, [
                _createElementVNode("small", { class: "text-muted" }, [
                  _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
                  _createTextVNode(" Cartão no tamanho 86mm x 54mm com linhas de corte para facilitar o acabamento ")
                ])
              ], -1))
            ]))
          : _createCommentVNode("", true),
        (!pdfUrl.value && !_unref(controle).erro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Carregando...")
              ], -1),
              _createElementVNode("p", { class: "mt-3" }, "Preparando cartão para impressão...", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})